import { Reducer } from 'redux';
import { ListOrganizationsDetailedResponse } from '../.generated/api';

export type OrganizationContractStatusFilter =
  | 'Expired'
  | 'ExpiringSoon'
  | 'Active';

export interface OrganizationListFilters {
  page: number;
  pageSize: number;
  name?: string;
  active?: boolean;
  contractStatus?: OrganizationContractStatusFilter;
}

export interface OrganizationListState {
  organizations: ListOrganizationsDetailedResponse | null | undefined;
  filters: OrganizationListFilters;
}
export interface OrganizationListSuccess {
  type: 'ORGANIZATION_LIST_SUCCESS';
  organizations: ListOrganizationsDetailedResponse | null | undefined;
  filters: OrganizationListFilters;
}

type OrganizationListActionTypes = OrganizationListSuccess;

const organizationListReducer: Reducer<
  OrganizationListState,
  OrganizationListActionTypes
> = (
  state: OrganizationListState | undefined,
  incomingAction: OrganizationListActionTypes,
): OrganizationListState => {
  if (state === undefined) {
    return {
      organizations: null,
      filters: {
        page: 1,
        pageSize: 25,
      },
    };
  }

  switch (incomingAction.type) {
    case 'ORGANIZATION_LIST_SUCCESS':
      return {
        organizations: incomingAction.organizations,
        filters: incomingAction.filters,
      };
    default:
      return state;
  }
};

export { organizationListReducer };
